import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ALLOWED_ROLES = new Set(["owner", "hr", "dev", "superadmin", "admin", "manager", "senior_manager"]);

export default function HHSyncIssuesButton() {
    const navigate = useNavigate();
    const { user } = useAuth();

    if (!ALLOWED_ROLES.has(String(user?.role || ""))) return null;
    return (
        <button
            type="button"
            onClick={() => navigate("/candidates/sync-issues")}
            className="relative inline-flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-600 shadow-sm transition-colors hover:border-rose-200 hover:bg-rose-50 hover:text-rose-700"
            aria-label="Несинхронизированные кандидаты"
            title="Кандидаты, чьи статусы отличаются от HH.ru"
        >
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M20 7h-7m7 0-2.5-2.5M20 7l-2.5 2.5M4 17h7m-7 0 2.5-2.5M4 17l2.5 2.5" />
                <path strokeLinecap="round" d="M7 7a5 5 0 0 1 5-3m5 13a5 5 0 0 1-5 3" />
            </svg>
            <span className="hidden xl:inline">Синхронизация HH</span>
        </button>
    );
}
